<template>
  <!-- begin:: Footer -->
  <div class="footer bg-white pt-6 d-flex flex-lg-column" id="kt_footer">
    <div
      class="d-flex align-items-center justify-content-center"
      v-bind:class="{ 'container-fluid': widthFluid, container: !widthFluid }"
    >
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            شماره پشتیبانی در واتس‌آپ:
            <a
              href="https://wa.me/989370885101"
              target="_blank"
              class="text-dark-75 text-hover-primary"
              dir="ltr"
            >
              0937-088-5101
            </a>
          </div>
          <div class="col-md-5">
            <div class="text-muted text-md-center">
              کلیه حقوق مادی و معنوی این سامانه متعلق به
              <a
                href="https://mirol.ir/"
                target="_blank"
                class="text-dark-75 text-hover-primary"
              >
                تکیه
              </a>
              می‌باشد.
            </div>
          </div>
          <div class="col-md-3">
            <div class="text-md-right">
              <span class="symbol-label mr-2">
                <a href="https://wa.me/+989370885101" target="_blank">
                  <i class="socicon-whatsapp text-primary mr-5 pt-1"></i>
                </a>
              </span>
              <span class="symbol-label mr-2">
                <a href="https://twitter.com/tekyemedia" target="_blank">
                  <i class="socicon-twitter text-primary mr-5 pt-1"></i>
                </a>
              </span>
              <span class="symbol-label mr-2">
                <a href="https://www.instagram.com/tekyemedia/" target="_blank">
                  <i class="socicon-instagram text-primary mr-5 pt-1"></i>
                </a>
              </span>
              <span class="symbol-label mr-2">
                <a href="https://t.me/tekyemedia" target="_blank">
                  <i class="socicon-telegram text-primary mr-5 pt-1"></i>
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end:: Footer -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "KTFooter",
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if footer container is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    }
  }
};
</script>
